<script lang="ts">
    // 상태 색점 + 라벨 + (선택) 원인 상세.
    //
    // 상세는 hover title 이 아니라 라벨 클릭(탭)으로 토글한다 — 터치 기기에는
    // hover 가 없어 title 만으로는 원인에 접근할 수 없기 때문. 색은 raw 팔레트
    // (bg-green-500 등) 대신 status-* 토큰을 쓴다: updateColorScheme() 이
    // 라이트/다크별 대비(WCAG)를 맞춘 값을 주입한다.
    import type { FeatureHealthLevel } from "src/ts/featureHealth.svelte";

    interface Props {
        level: FeatureHealthLevel;
        label: string;
        detail?: string;
    }
    let { level, label, detail = "" }: Props = $props();
    let showDetail = $state(false);

    const dotColor = $derived(
        level === "ok" ? "bg-status-ok"
        : level === "error" ? "bg-status-bad"
        : level === "unconfigured" ? "bg-status-setup"
        : "bg-status-off"
    );
</script>

<span class="inline-flex items-center gap-1 text-xs font-normal text-textcolor2 flex-wrap">
    <!-- 점은 순수 장식: 의미는 옆 라벨 텍스트가 전달하므로 스크린리더에서 숨긴다. -->
    <span class="w-2 h-2 rounded-full shrink-0 {dotColor}" aria-hidden="true"></span>
    {#if detail}
        <button type="button"
            class="underline decoration-dotted underline-offset-2 cursor-pointer hover:text-textcolor text-left"
            onclick={() => { showDetail = !showDetail }}>{label}</button>
        {#if showDetail}
            <span class="basis-full wrap-break-word">{detail}</span>
        {/if}
    {:else}
        <span>{label}</span>
    {/if}
</span>
